import { createFileRoute } from '@tanstack/react-router'

import { UserManagement } from '../../../components/app/user-management/UserManagement'

export const Route = createFileRoute('/app/settings/user-management')({
  component: UserManagementComponent,
})

function UserManagementComponent() {
  return <UserManagement />
}
